export default "__VITE_ASSET__CITeoYKM__"